import type { IContainer } from '@monofe/di';
import { injectOrBuildContainer } from '@monofe/di';
import type { IMediaCacheController } from './cache';

export const TYPES = {
    IMediaCacheController: Symbol.for('IMediaCacheController'),
};

export function injectMediaCacheController(
    container: IContainer = injectOrBuildContainer(),
): IMediaCacheController {
    return container.get<IMediaCacheController>(TYPES.IMediaCacheController);
}

export function bindMediaCacheController(
    val: IMediaCacheController,
    container: IContainer = injectOrBuildContainer(),
): void {
    container.bind<IMediaCacheController>(TYPES.IMediaCacheController, val);
}

export function unbindMediaCacheController(container: IContainer = injectOrBuildContainer()): void {
    container.remove(TYPES.IMediaCacheController);
}
